import { userDetailsReducer } from "./userDetails/reducer";
import { createStore, combineReducers } from "redux";
import { skillReducer } from "./skill/reducer/index";
import { degreeReducer } from "./degree/reducer/index";
import { courseReducer } from "./course/reducer";
import { eventReducer } from "./events/reducer";
import { eventsCrud } from "./eventsCrud/reducer";
import { userReducer } from "./user/reducer";
import { thoughtLeaderReducer } from "./thoughtLeader/reducer";
import { groupReducer } from "./group/reducer";
import { courseCrud } from "./courseCrud/reducer";
import { peakListReducer } from "./peakList/reducer";
import { postReducer } from "./post/reducer";
import { groupDiscussionReducer } from "./GroupDiscussion/reducer";
import { requestList } from "./RequestList/reducer";
import { preCollageUserReducer } from "./preCollageUser/reducer";
import { careerLaunchUserReducer } from "./careerLaunchUser/reducer";
import { reportReducer } from "./report/reducer";
import { applicationReducer } from "./Applications/reducer"
import {CertCourseUserReducer} from "./CertCourseUser/reducer"
import {certificatesReducer} from "./Certificates/reducer";
import {DlUserReducer} from "./DlUser/reducer"
import { contributorReducer } from "./ContributorsUser/reducer"

export const store = createStore(
  combineReducers({
    preCollageUserReducer,
    careerLaunchUserReducer,
    postReducer,
    userDetailsReducer,
    skillReducer,
    degreeReducer,
    courseReducer,
    courseCrud,
    userReducer,
    peakListReducer,
    thoughtLeaderReducer,
    groupReducer,
    eventsCrud,
    eventReducer,
    groupDiscussionReducer,
    requestList,
    reportReducer,
    applicationReducer,
    CertCourseUserReducer,
    certificatesReducer,
    DlUserReducer,
    contributorReducer,
  })
);
